module.exports = __webpack_public_path__ + "static/sohomaextrabold-c4d9ffef082b17eada5322423db88635.woff2";